import React, { useRef, useState } from "react";

import { Form, Button, Container, Row, Col, Spinner } from "react-bootstrap";

const SendOnboardingEmailsForm = () => {
  const [validated, setValidated] = useState(false);
  const [sendingMessage, setSendingMessage] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: "idle", message: "" });

  const recipientEmailAddress = useRef("");
  const companyName = useRef("");
  const username = useRef("");
  const password = useRef("");
  const customMessage = useRef("");

  async function submitHandler(event) {
    event.preventDefault();

    // could add validation here...
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      const webhookUrl = process.env.REACT_APP_ONBOARDING_WEBHOOK_URL;

      if (!webhookUrl) {
        setSubmitStatus({
          type: "error",
          message: "Missing webhook URL. Set REACT_APP_ONBOARDING_WEBHOOK_URL.",
        });
        setValidated(true);
        return;
      }

      setSendingMessage(true);
      setSubmitStatus({ type: "idle", message: "" });

      try {
        const onboardingMailValues = {
          recipientEmailAddress: recipientEmailAddress.current.value.trim(),
          companyName: companyName.current.value.trim(),
          username: username.current.value.trim(),
          customMessage: customMessage.current.value.trim(),
        };
        const response = await fetch(webhookUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(onboardingMailValues),
        });

        if (!response.ok) {
          throw new Error(`Webhook request failed: ${response.status}`);
        }

        setSubmitStatus({
          type: "success",
          message: "Sent successfully.",
        });
        form.reset();
        setValidated(false);
      } catch (error) {
        setSubmitStatus({
          type: "error",
          message: "Failed to send. Please try again.",
        });
      } finally {
        setSendingMessage(false);
      }
    }

    setValidated(true);
  }

  return (
    <Container>
      <Row>
        <Col md={12} className="text-center mb-5">
          <h2 className="component-title">Web Application User Account Details Form</h2>
        </Col>
        <Col md={6} className="mx-auto">
          {submitStatus.type === "success" ? (
            <div className="text-center">
              <p className="mb-4">Message sent. Thank you.</p>
              <Button variant="secondary" onClick={() => window.location.reload()}>
                Reload
              </Button>
            </div>
          ) : (
            <Form noValidate validated={validated} className="row" onSubmit={submitHandler}>
              <Form.Group className="mb-3 col-md-6" controlId="recipientEmailAddress">
                {/* <Form.Label>Email Address</Form.Label> */}
                <Form.Control required type="email" placeholder="User email" ref={recipientEmailAddress} />
                {/* <Form.Text className="text-muted">Please enter the recipient email address.</Form.Text> */}
              </Form.Group>

              <Form.Group className="mb-3 col-md-6" controlId="companyName">
                {/* <Form.Label>Company Name</Form.Label> */}
                <Form.Control required type="text" placeholder="Company name" ref={companyName} />
              </Form.Group>

              <Form.Group className="mb-3 col-md-6" controlId="username">
                {/* <Form.Label>Username</Form.Label> */}
                <Form.Control required type="text" placeholder="Username" ref={username} />
              </Form.Group>

              <Form.Group className="mb-3 col-md-6" controlId="password">
                {/* <Form.Label>Password</Form.Label> */}
                <Form.Control type="password" placeholder="Password" ref={password} />
              </Form.Group>


              <Form.Group className="mb-3 col-md-12" controlId="customMessage">
                {/* <Form.Label>Custom message (optional)</Form.Label> */}
                <Form.Control as="textarea" rows={3} placeholder="(Optional) Start typing a message." ref={customMessage} />
                <Form.Text className="text-muted">This is optional. If completed a custom message will be added to the onboarding email.</Form.Text>
              </Form.Group>

              <Form.Group className="mb-3 col-md-12" controlId="customMessage">
                <Button variant="secondary" className="col-12" type="submit" disabled={sendingMessage}>
                  {!sendingMessage ? "Send" : <Spinner animation="border" />}
                </Button>
              </Form.Group>
              {submitStatus.type !== "idle" && (
                <Form.Text className={submitStatus.type === "error" ? "text-danger" : "text-success"}>
                  {submitStatus.message}
                </Form.Text>
              )}
            </Form>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default SendOnboardingEmailsForm;
